import { PORT_FROM } from 'app/commons/constants/image.const'

import React from 'react'

import './styles.scss'

const Port = () => {
  return <div className="point-port" style={{ backgroundImage: `url(${PORT_FROM})` }}></div>
}

export default Port
